/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:e0e68410-491a-426b-a0a3-9523cf77baf4",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_M6YLuVUOP",
    "aws_user_pools_web_client_id": "37bet91qvi5s4cbofto986guhr",
    "oauth": {
        "domain": "fincraftapp5d050b9a-5d050b9a-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.fincraft.de/",
        "redirectSignOut": "https://app.fincraft.de/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_mobile_analytics_app_id": "352d5f0e6d744ae6a4735a3d5833ab0f",
    "aws_mobile_analytics_app_region": "eu-central-1",
    "aws_user_files_s3_bucket": "fincraft-app5535d506e87c4e42b07cec67df6d0555prod-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
